<header class="wow fadeInUp exam live-class-header" [ngClass]="{'landscape-hide': (enableLcUIChanges && isLandScape && isStudentLiveClassPage)}" data-wow-delay="0.2s">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <a class="logo" (click)="logoClicked()" ><img src="assets/img/marketing-page-logo.png" alt="Infinity Learn"> </a>
        <div class="hamburger-menu"> <span></span> <span></span> <span></span> </div>
        <div class="logo-right">
          <!-- <div></div> -->
          <p class="exam-type" [ngClass]="{'active-class-name': liveClassDetails?.title}">
            <span
              *ngIf="liveClassDetails?.title">{{liveClassDetails?.title}}</span>
          </p>
          <div class="exam-settings" *ngIf="isShownRightMenu">
            <div class="exam-timer" *ngIf="(userTypeId == 2 && display)">
              <p class="{{timeOver ? 'text-danger' : ''}}">
                <img class="icon-18 m-hide lc-class-timer-icon"
                  src="{{timeOver ? 'assets/img/timer-icon-danger.svg' : 'assets/img/timer-icon.svg' }}" alt=""> <img
                  class="icon-18 m-show d-inline-block" src="assets/img/timer-icon-white.svg" alt="">
                <span class="m-hide" *ngIf="timeOver; then thenBlock else elseBlock"></span>
                <ng-template #thenBlock>Class will end in 10 minutes:</ng-template>
                <ng-template #elseBlock>Time remaining:</ng-template>
                <span class="assessment_pl-2 lc-class-timer">
                  {{display}}</span>
              </p>
            </div>
            <div class="dropdown instruction-dropdown joining-class-dropdown m-hide" *ngIf="!isRecordingClass">
              <button class="dropdown-toggle" type="button" (click)="showSessionInfo()">
                <img src="assets/img/session-details-icon.svg" alt="Instructions">
              </button>
            </div>

            <div class="dropdown instruction-dropdown joining-class-dropdown report-an-issue-icon m-hide"
              *ngIf="!isRecordingClass">

              <ng-container>
                <button class="dropdown-toggle" (click)="reportAnIssue()"><img src="assets/img/report-an-issue-icon.svg"
                    alt="Question List"></button>
              </ng-container>

            </div>


            <div class="dropdown instruction-dropdown joining-class-dropdown report-an-issue-icon d-hide">
                <button class="dropdown-toggle light-blue" (click)="mob_hdr_btn_action()"><img src="assets/img/three-v-icon.svg"
                    alt="mobile menu list"></button>
                    <ul class="dropdown-sublist-box" [ngClass]="mob_hdr_btn_action_status?'show':''">
                      <li (click)="showSessionInfo()">
                        <img src="assets/img/info-icon.svg" class="icn"><span>Class Info</span>
                      </li>
                      <li (click)="reportAnIssue()" >
                        <img src="assets/img/flag-line-dark-icon.svg"class="icn"><span>Report Issue</span>
                      </li>
                    </ul>
            </div>

            <button class="btn btn-danger leave-session" [ngClass]="{'disabled': isDisabledLiveClassMenus}"
              type="button" (click)="leaveSession()" *ngIf="!isSessionEnd && liveClassDetails && !isRecordingClass"
              [disabled]="isDisabledLiveClassMenus || !isEnabledLeaveSession">
              <div *ngIf="userTypeId == 2; then thenBlock else elseBlock"></div>
              <ng-template #thenBlock>
                <img class="d-lg-none d-md-none d-sm-block" src="assets/img/leave-class.svg" alt="">
                <span class="d-lg-block d-md-block d-sm-none">
                  End class
                </span>
              </ng-template>
              <ng-template #elseBlock>
                <img class="d-lg-none d-md-none d-sm-block" src="assets/img/leave-class.svg" alt="">
                <span class="d-lg-block d-md-block d-sm-none">
                  Leave class
                </span>
              </ng-template>
            </button>

          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <p class="exam-type d-md-none d-sm-block res-course-name">{{liveClassDetails?.title}}</p> -->
</header>
<div *ngIf="isRecordingClass" id="recording-loader"></div>